<template>
  <!-- icon.custom means it's not FontAwesome -->
  <svg
    v-if="!icon.custom"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="icon.viewBox"
    stroke="currentColor"
    fill="currentColor"
  >
    <path
      v-if="icon.d2"
      class="opacity-40"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      :d="icon.d2"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      :d="icon.d"
    />
  </svg>

  <div
    v-else-if="name === 'kobler'"
    class="inline-flex justify-center align-middle"
  >
    <img src="@/assets/kobler_logo.png" />
  </div>

  <div
    v-else-if="name === 'adform'"
    class="inline-flex justify-center align-middle"
  >
    <img src="@/assets/adform_logo.png" />
  </div>

  <div
    v-else-if="name === 'matomo'"
    class="inline-flex justify-center align-middle"
  >
    <img src="@/assets/matomo_logo.svg" />
  </div>

  <div
    v-else-if="name === 'omnium'"
    class="inline-flex justify-center align-middle"
  >
    <img src="@/assets/omnium_logo.png" alt="" aria-hidden="true" />
  </div>

  <div v-else-if="name === 'small-cross'">
    <svg
      width="7"
      height="7"
      viewBox="0 0 7 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.48205 3.25L6.32993 1.40212C6.55669 1.17535 6.55669 0.807699 6.32993 0.580753L5.91925 0.170071C5.69249 -0.0566903 5.32483 -0.0566903 5.09788 0.170071L3.25 2.01795L1.40212 0.170071C1.17536 -0.0566903 0.807699 -0.0566903 0.580753 0.170071L0.170071 0.580753C-0.0566903 0.807514 -0.0566903 1.17517 0.170071 1.40212L2.01795 3.25L0.170071 5.09788C-0.0566903 5.32464 -0.0566903 5.6923 0.170071 5.91925L0.580753 6.32993C0.807514 6.55669 1.17536 6.55669 1.40212 6.32993L3.25 4.48205L5.09788 6.32993C5.32465 6.55669 5.69249 6.55669 5.91925 6.32993L6.32993 5.91925C6.55669 5.69249 6.55669 5.32483 6.32993 5.09788L4.48205 3.25Z"
        fill="white"
      />
    </svg>
  </div>

  <FyrAiLogo v-else-if="name === 'fyr-ai'" />

  <svg v-else :viewBox="icon.viewBox">
    <g
      v-if="name === 'google-analytics'"
      transform="matrix(.363638 0 0 .363636 -3.272763 -2.909091)"
    >
      <path
        d="M130 29v132c0 14.77 10.2 23 21 23 10 0 21-7 21-23V30c0-13.54-10-22-21-22s-21 9.33-21 21z"
        :fill="overrideColor ? 'currentColor' : '#f9ab00'"
      />
      <g :fill="overrideColor ? 'currentColor' : '#e37400'">
        <path
          d="M75 96v65c0 14.77 10.2 23 21 23 10 0 21-7 21-23V97c0-13.54-10-22-21-22s-21 9.33-21 21z"
        />
        <circle cx="41" cy="163" r="21" />
      </g>
    </g>

    <g
      v-if="name === 'google-ads'"
      transform="matrix(.257748 0 0 .257745 -.361416 2.515516)"
    >
      <clipPath v-if="name === 'google-ads'">
        <path d="m0 0h250.9v312.8h-250.9z" />
      </clipPath>
      <path
        d="m85.9 28.6c2.4-6.3 5.7-12.1 10.6-16.8 19.6-19.1 52-14.3 65.3 9.7 10 18.2 20.6 36 30.9 54l51.6 89.8c14.3 25.1-1.2 56.8-29.6 61.1-17.4 2.6-33.7-5.4-42.7-21l-45.4-78.8c-.3-.6-.7-1.1-1.1-1.6-1.6-1.3-2.3-3.2-3.3-4.9l-33.4-57.9c-3.9-6.8-5.7-14.2-5.5-22 .3-4 .8-8 2.6-11.6"
        :fill="overrideColor ? 'currentColor' : '#3c8bd9'"
      />
      <path
        d="m85.9 28.6c-.9 3.6-1.7 7.2-1.9 11-.3 8.4 1.8 16.2 6 23.5l32.9 56.9c1 1.7 1.8 3.4 2.8 5l-18.1 31.1-25.3 43.6c-.4 0-.5-.2-.6-.5-.1-.8.2-1.5.4-2.3 4.1-15 .7-28.3-9.6-39.7-6.3-6.9-14.3-10.8-23.5-12.1-12-1.7-22.6 1.4-32.1 8.9-1.7 1.3-2.8 3.2-4.8 4.2-.4 0-.6-.2-.7-.5l14.3-24.9 59.5-103.1c.2-.4.5-.7.7-1.1"
        :fill="overrideColor ? 'currentColor' : '#fabc04'"
      />
      <path
        d="m11.8 158 5.7-5.1c24.3-19.2 60.8-5.3 66.1 25.1 1.3 7.3.6 14.3-1.6 21.3-.1.6-.2 1.1-.4 1.7-.9 1.6-1.7 3.3-2.7 4.9-8.9 14.7-22 22-39.2 20.9-19.7-1.4-35.2-16.2-37.9-35.8-1.3-9.5.6-18.4 5.5-26.6 1-1.8 2.2-3.4 3.3-5.2.5-.4.3-1.2 1.2-1.2"
        :fill="overrideColor ? 'currentColor' : '#34a852'"
      />
      <path
        d="m11.8 158c-.4.4-.4 1.1-1.1 1.2-.1-.7.3-1.1.7-1.6z"
        :fill="overrideColor ? 'currentColor' : '#fabc04'"
      />
      <path
        d="m81.6 201c-.4-.7 0-1.2.4-1.7l.4.4z"
        :fill="overrideColor ? 'currentColor' : '#e1c025'"
      />
    </g>

    <g v-if="name === 'google-search-console'">
      <path
        d="M83 22l22-22v42H83zM213 22L191 0v42h22z"
        :fill="overrideColor ? 'currentColor' : '#7b7b7b'"
        fill-rule="evenodd"
      />
      <path d="M105 0h86v21h-86z" fill="#5a5a5a" />
      <g fill-rule="evenodd">
        <path
          d="M272 264H24a24 24 0 0 1-24-24V83.238L41.238 42h213.524L296 83.238V240a24 24 0 0 1-24 24z"
          :fill="overrideColor ? '' : '#e6e7e8'"
        />
        <path
          d="M0 127V83.238L41.238 42h213.524L296 83.238V127z"
          :fill="overrideColor ? '' : '#d0d1d2'"
        />
        <path
          d="M34 264V94a10 10 0 0 1 10-10h208a10 10 0 0 1 10 10v170z"
          :fill="overrideColor ? '' : '#458cf5'"
        />
      </g>
      <path d="M34 127h228v137H34z" :fill="overrideColor ? '' : '#fff'" />
      <path
        d="M194 264v-41l-20-20-13-36 9-23 51 51 9-38 32 32v75z"
        :fill="overrideColor ? '' : '#d2d3d4'"
        fill-rule="evenodd"
      />
      <path
        d="M49 143h76v85H49zM49 247h98v17H49z"
        :fill="overrideColor ? 'currentColor' : '#d2d3d4'"
      />
      <path
        d="M213 232.1V264h-42v-31.447a49.507 49.507 0 0 1-1-89.651V190l21 13 22-13v-47.1a49.518 49.518 0 0 1 0 89.2z"
        :fill="overrideColor ? 'currentColor' : '#505050'"
        fill-rule="evenodd"
      />
      <path
        d="M57.5 95a8.5 8.5 0 1 1-8.5 8.5 8.5 8.5 0 0 1 8.5-8.5zm25 0a8.5 8.5 0 1 1-8.5 8.5 8.5 8.5 0 0 1 8.5-8.5z"
        :fill="overrideColor ? 'currentColor' : '#e6e7e8'"
        fill-rule="evenodd"
      />
    </g>
    <g v-if="name === 'google-cm360'">
      <path
        d="M15.8203 0c-2.093.0002-4.1858.7997-5.7832 2.3965-1.3364 1.3364-2.112 3.0208-2.33 4.7617a8.731 8.731 0 0 1 .4726-.0137c1.7849-.0001 3.5658.5466 5.0763 1.6387-.2066-.8822.0681-1.8261.7127-2.4707 1.046-1.0459 2.7113-.9977 3.7149.0059 1.0827 1.0826 2.8372 1.0826 3.92 0 1.0826-1.084 1.0826-2.8392 0-3.922C20.006.7992 17.9133-.0001 15.8202 0Zm7.0781 4.0781c.0785.929-.234 1.8855-.9414 2.5938-.9808.9809-2.438 1.2037-3.6386.6738.3115.9383.065 1.9896-.6329 2.6875-.9913.9913-2.6633 1.0662-3.7255.0039-.0173-.0172-.0293-.0352-.046-.0527l-.003.002c-3.1988-3.142-8.3393-3.1251-11.5165.0507-3.1935 3.1935-3.1935 8.373 0 11.5664 1.1618 1.1618 3.0453 1.1618 4.207 0 1.1618-1.1618.8689-2.7562-.293-3.918-.9353-.9354-1.1225-2.5928-.0058-3.7109.9095-.9095 2.5376-1.1696 3.7266-.0078.0726.0726.1477.1405.2246.2031 3.208 2.9849 8.2258 2.9155 11.3496-.207 2.68-2.679 3.1113-6.7548 1.295-9.8848zM10.7246 15.1992c.2151.8774-.0348 1.8317-.7012 2.498-.6718.672-1.6786.924-2.5918.6583.2105.3921.3471.8085.3926 1.2363.088.8272-.1925 1.6886-.8691 2.3652-.7565.7566-1.781 1.0896-2.7735 1 3.1157 1.7478 7.1304 1.2962 9.7813-1.3535 1.337-1.3364 2.1102-3.0208 2.3281-4.7617-1.946.1045-3.9194-.4446-5.5664-1.6426z"
        :fill="overrideColor ? 'currentColor' : '#65A30D'"
      />
    </g>
    <g v-if="name === 'google-dv360'">
      <path
        d="M1730.6,949.3c142.5-86.5,328.1-41.1,414.5,101.4c86.5,142.5,41.1,328.1-101.4,414.5
        c-3.8,2.3-7.6,4.5-11.4,6.6L460.2,2377.1c-142.5,86.5-328.1,41.1-414.6-101.4c-86.5-142.5-41.1-328.1,101.4-414.6
        c3.8-2.3,7.6-4.5,11.4-6.6L1730.6,949.3z"
        :fill="overrideColor ? 'currentColor' : '#81C995'"
      />
      <path
        d="M601,303.7C601.7,137.4,467.4,1.9,301.1,1.2c-21.4-0.1-42.7,2.1-63.7,6.5C96.5,42.3-2,169.5,0,314.7v1798.1
        l600.4,10.9L601,303.7z"
        :fill="overrideColor ? 'currentColor' : '#34A853'"
      />
      <path
        d="M1737.4,1472.9c145.3,75.3,324.1,27.1,411.9-111.1c84.4-142,37.7-325.6-104.3-410c-1.1-0.6-2.1-1.2-3.2-1.9
        L459.2,43C318.3-42.1,135,3.1,49.8,144c-2.1,3.5-4.2,7.1-6.2,10.7C-40,297.8,8.2,481.7,151.3,565.4c1,0.6,2,1.1,3,1.7
        L1737.4,1472.9z"
        :fill="overrideColor ? 'currentColor' : '#5BB974'"
      />
      <path
        d="M2031.4,1475L600.5,2274.3v-686.6l1135.4-633.1c150.5-83.4,340.2-29,423.6,121.6c7.8,14,14.4,28.6,19.9,43.6
        C2222,1258.3,2159.8,1407.6,2031.4,1475z"
        :fill="overrideColor ? 'currentColor' : '#81C995'"
      />
      <circle
        cx="300.8"
        cy="2127.8"
        r="300.2"
        :fill="overrideColor ? 'currentColor' : '#1E8E3E'"
      />
    </g>

    <g v-if="name === 'snapchat-ghost'">
      <path
        d="M417.93 340.71c-60.61-29.34-70.27-74.64-70.7-78-.52-4.07-1.11-7.27 3.38-11.41 4.33-4 23.54-15.89 28.87-19.61 8.81-6.16 12.69-12.31 9.83-19.87-2-5.23-6.87-7.2-12-7.2a22.3 22.3 0 0 0-4.81.54c-9.68 2.1-19.08 6.95-24.52 8.26a8.56 8.56 0 0 1-2 .27c-2.9 0-4-1.29-3.72-4.78.68-10.58 2.12-31.23.45-50.52-2.29-26.54-10.85-39.69-21-51.32C316.8 101.43 294 77.2 250 77.2s-66.77 24.23-71.65 29.8c-10.18 11.63-18.73 24.78-21 51.32-1.67 19.29-.17 39.93.45 50.52.2 3.32-.82 4.78-3.72 4.78a8.64 8.64 0 0 1-2-.27c-5.43-1.31-14.83-6.16-24.51-8.26a22.3 22.3 0 0 0-4.81-.54c-5.15 0-10 2-12 7.2-2.86 7.56 1 13.71 9.84 19.87 5.33 3.72 24.54 15.6 28.87 19.61 4.48 4.14 3.9 7.34 3.38 11.41-.43 3.41-10.1 48.71-70.7 78-3.55 1.72-9.59 5.36 1.06 11.24 16.72 9.24 27.85 8.25 36.5 13.82 7.34 4.73 3 14.93 8.34 18.61 6.56 4.53 25.95-.32 51 7.95 21 6.92 33.76 26.47 71 26.47s50.37-19.64 71-26.47c25-8.27 44.43-3.42 51-7.95 5.33-3.68 1-13.88 8.34-18.61 8.65-5.57 19.77-4.58 36.5-13.82 10.63-5.81 4.59-9.45 1.04-11.17Z"
        :fill="overrideColor ? 'currentColor' : '#fff'"
      />
      <path
        d="M444.3 337.26c-2.72-7.4-7.9-11.36-13.8-14.64a34.51 34.51 0 0 0-3-1.57c-1.76-.91-3.56-1.79-5.35-2.72-18.39-9.75-32.75-22.05-42.71-36.63a83.06 83.06 0 0 1-7.33-13c-.85-2.43-.81-3.81-.2-5.07a8.25 8.25 0 0 1 2.35-2.45c3.16-2.09 6.42-4.21 8.63-5.64 3.94-2.55 7.06-4.57 9.07-6 7.55-5.28 12.83-10.89 16.13-17.16a34.17 34.17 0 0 0 1.69-28.38c-5-13.16-17.43-21.33-32.49-21.33a44.75 44.75 0 0 0-9.45 1c-.83.18-1.66.37-2.47.58.14-9-.06-18.5-.86-27.85-2.84-32.87-14.35-50.1-26.35-63.84A105 105 0 0 0 311.37 71C293.16 60.6 272.51 55.32 250 55.32S206.94 60.6 188.71 71a104.62 104.62 0 0 0-26.84 21.6c-12 13.74-23.51 31-26.35 63.84-.8 9.35-1 18.9-.87 27.85-.81-.21-1.63-.4-2.46-.58a44.75 44.75 0 0 0-9.45-1c-15.07 0-27.52 8.17-32.5 21.33a34.21 34.21 0 0 0 1.65 28.41c3.31 6.27 8.59 11.88 16.14 17.16 2 1.4 5.13 3.42 9.07 6 2.13 1.38 5.24 3.4 8.29 5.42a8.9 8.9 0 0 1 2.66 2.67c.64 1.31.66 2.72-.29 5.32a82.29 82.29 0 0 1-7.21 12.73c-9.74 14.25-23.68 26.33-41.48 36-9.43 5-19.23 8.34-23.37 19.59-3.12 8.49-1.08 18.15 6.85 26.29a39.63 39.63 0 0 0 10 7.57 108.35 108.35 0 0 0 24.47 9.79 16.16 16.16 0 0 1 4.94 2.21c2.89 2.53 2.48 6.34 6.33 11.92a27.8 27.8 0 0 0 7.24 7.36c8.08 5.58 17.16 5.93 26.78 6.3 8.69.33 18.54.71 29.79 4.42 4.66 1.54 9.5 4.52 15.11 8 13.47 8.28 31.91 19.61 62.77 19.61s49.43-11.39 63-19.7c5.57-3.42 10.38-6.37 14.91-7.87 11.25-3.72 21.1-4.09 29.79-4.42 9.62-.37 18.7-.72 26.78-6.3a27.89 27.89 0 0 0 8.24-9c2.77-4.71 2.7-8 5.3-10.3a15.32 15.32 0 0 1 4.64-2.12 108.76 108.76 0 0 0 24.8-9.88 39 39 0 0 0 10.5-8.22l.1-.12c7.44-7.96 9.31-17.34 6.26-25.62ZM416.87 352c-16.73 9.24-27.85 8.25-36.5 13.82-7.35 4.73-3 14.93-8.34 18.61-6.56 4.53-25.95-.32-51 7.95-20.66 6.83-33.84 26.47-71 26.47S200 399.25 179 392.33c-25-8.27-44.43-3.42-51-7.95-5.33-3.68-1-13.88-8.34-18.61-8.66-5.57-19.78-4.58-36.5-13.77-10.65-5.88-4.61-9.52-1.06-11.24 60.6-29.34 70.27-74.64 70.7-78 .52-4.07 1.1-7.27-3.38-11.41-4.33-4-23.54-15.89-28.87-19.61-8.82-6.16-12.7-12.31-9.84-19.87 2-5.23 6.88-7.2 12-7.2a22.3 22.3 0 0 1 4.81.54c9.68 2.1 19.08 6.95 24.51 8.26a8.64 8.64 0 0 0 2 .27c2.9 0 3.92-1.46 3.72-4.78-.62-10.59-2.12-31.23-.45-50.52 2.29-26.54 10.84-39.69 21-51.32 4.88-5.59 27.81-29.82 71.66-29.82s66.84 24.13 71.72 29.7c10.17 11.63 18.73 24.78 21 51.32 1.67 19.29.23 39.94-.45 50.52-.23 3.49.82 4.78 3.72 4.78a8.56 8.56 0 0 0 2-.27c5.44-1.31 14.84-6.16 24.52-8.26a22.3 22.3 0 0 1 4.81-.54c5.15 0 10 2 12 7.2 2.86 7.56-1 13.71-9.83 19.87-5.33 3.72-24.54 15.6-28.87 19.61-4.49 4.14-3.9 7.34-3.38 11.41.43 3.41 10.09 48.71 70.7 78 3.58 1.79 9.62 5.43-1.03 11.36Z"
      />
    </g>
    <g v-if="name === 'xandr'">
      <path
        d="M128 100.946L69.7183 1.01902e-05L186.281 0L128 100.946Z"
        fill="#E34C3B"
      />
      <path
        d="M128.968 129.996L187.249 230.942L70.6866 230.942L128.968 129.996Z"
        fill="#ED9482"
      />
      <path
        d="M198.686 7.02026L256.968 107.967H140.405L198.686 7.02026Z"
        fill="#E9614E"
      />
      <path
        d="M58.2814 223.922L6.43378e-06 122.975L116.563 122.975L58.2814 223.922Z"
        fill="#E9614E"
      />
      <path
        d="M58.2814 7.02026L116.563 107.967H0L58.2814 7.02026Z"
        fill="#CE3519"
      />
      <path
        d="M198.686 223.922L140.405 122.975L256.968 122.975L198.686 223.922Z"
        fill="#ED7B66"
      />
    </g>
    <g v-if="name === 'fyr-logo'">
      <path
        d="M221.7,112.8h-72.5c-7.4,0-13.4-6-13.4-13.4V51.8c0-7.4,6-13.4,13.4-13.4h72.5c7.4,0,13.4,6,13.4,13.4v47.6
		C235.1,106.8,229.1,112.8,221.7,112.8z"
        fill="currentColor"
      />
      <path
        d="M110,249.6H47.5c-7.4,0-13.4-6-13.4-13.4V52.1c0-7.4,6-13.4,13.4-13.4H110c7.4,0,13.4,6,13.4,13.4v184.1
		C123.4,243.6,117.4,249.6,110,249.6z"
        fill="currentColor"
      />
      <path
        d="M165.7,186.5L165.7,186.5c-17.9,0-32.4-14.5-32.4-32.4v0c0-17.9,14.5-32.4,32.4-32.4h0
		c17.9,0,32.4,14.5,32.4,32.4v0C198.1,172,183.6,186.5,165.7,186.5z"
        fill="currentColor"
      />
    </g>
    <g v-if="name === 'google-merchant-center'">
      <defs>
        <linearGradient id="a" x1="100%" x2="0%" y1="100%" y2="0%">
          <stop offset="0" stop-color="#4385f5" />
          <stop offset="1" stop-color="#3569d3" />
        </linearGradient>
        <path
          id="c"
          d="M137.5 201c-8.56 0-15.5-6.94-15.5-15.5s6.94-15.5 15.5-15.5 15.5 6.94 15.5 15.5-6.94 15.5-15.5 15.5zm165.364 47.632l-93.6-93.6C205.52 151.288 200.32 149 194.6 149h-72.8a20.728 20.728 0 0 0-20.8 20.8v72.8c0 5.72 2.288 10.92 6.136 14.664l93.496 93.6C204.48 354.608 209.68 357 215.4 357s10.92-2.392 14.664-6.136l72.8-72.8C306.712 274.32 309 269.12 309 263.4c0-5.824-2.392-11.024-6.136-14.768z"
        />
        <filter id="b" height="120.7%" width="120.7%" x="-8.4%" y="-8.4%">
          <feOffset
            dx="4"
            dy="4"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
            stdDeviation="6.5"
          />
          <feColorMatrix
            in="shadowBlurOuter1"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
        </filter>
      </defs>
      <g fill="none" fill-rule="evenodd">
        <path
          d="M.2 98.333h409.6V375.67c0 18.85-15.278 34.13-34.13 34.13H34.33C15.48 409.8.2 394.514.2 375.67z"
          fill="#518ff5"
        />
        <path
          d="M144.713 294.215l106.371-97.264L410 355.63l-.074 20.037c-.07 18.851-15.405 34.134-34.26 34.134H260.808z"
          fill="url(#a)"
        />
        <path
          d="M.2 34.333C.2 15.482 15.478.2 34.33.2h341.34c18.85 0 34.13 15.28 34.13 34.133v64H.2z"
          fill="#4758b8"
        />
        <path
          d="M187.933 47.133h-40.539c-8.245 0-14.927 6.686-14.927 14.934 0 8.249 6.683 14.933 14.927 14.933h115.212c8.245 0 14.927-6.686 14.927-14.933 0-8.25-6.683-14.934-14.927-14.934h-40.54v-4.266c0-9.43-7.64-17.067-17.066-17.067-9.428 0-17.067 7.641-17.067 17.067z"
          fill="#fff"
        />
        <g fill-rule="nonzero">
          <use fill="#000" filter="url(#b)" xlink:href="#c" />
          <use fill="#fff" fill-rule="evenodd" xlink:href="#c" />
        </g>
      </g>
    </g>
    <g v-if="name === 'microsoft'" fill="none">
      <path fill="#ff5722" d="M6 6H22V22H6z" transform="rotate(-180 14 14)" />
      <path fill="#4caf50" d="M26 6H42V22H26z" transform="rotate(-180 34 14)" />
      <path
        fill="#ffc107"
        d="M26 26H42V42H26z"
        transform="rotate(-180 34 34)"
      />
      <path fill="#03a9f4" d="M6 26H22V42H6z" transform="rotate(-180 14 34)" />
    </g>
    <g v-if="name === 'googleSheets'" fill="none">
      <path d="M 42,0 64,22 53,24 42,22 40,11 Z" fill="#188038" />
      <path
        d="M 42,22 V 0 H 6 C 2.685,0 0,2.685 0,6 v 76 c 0,3.315 2.685,6 6,6 h 52 c 3.315,0 6,-2.685 6,-6 V 22 Z"
        fill="#34a853"
      />
      <path
        d="M 12,34 V 63 H 52 V 34 Z M 29.5,58 H 17 v -7 h 12.5 z m 0,-12 H 17 V 39 H 29.5 Z M 47,58 H 34.5 V 51 H 47 Z M 47,46 H 34.5 V 39 H 47 Z"
        fill="#fff"
      />
    </g>
    <g v-if="name === 'googleDrive'" fill="none" clip-path="url(#clip0_1_478)">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M2.5 7.5V13C2.5 13.2762 2.72375 13.5 3 13.5H9C9.27625 13.5 9.5 13.2762 9.5 13V7.5C9.5 7.22375 9.27625 7 9 7H3C2.72375 7 2.5 7.22375 2.5 7.5ZM6.5 8.5H8.5V10H6.5V8.5ZM6.5 11H8.5V12.5H6.5V11ZM3.5 8.5H5.5V10H3.5V8.5ZM3.5 11H5.5V12.5H3.5V11ZM11.5572 3.06188L8.93563 0.440625C8.65438 0.159375 8.27312 0 7.87656 0H1.49969C0.671875 0.003125 0 0.675 0 1.50281V14.5003C0 15.3281 0.671875 16 1.49969 16H10.4978C11.3259 16 12 15.3281 12 14.5003V4.12406C12 3.7275 11.8384 3.34313 11.5572 3.06188ZM7.99844 1.62469L10.3763 4.00219H7.99844V1.62469ZM10.5 14.5003H1.49969V1.50281H6.49875V4.75219C6.49875 5.16781 6.83313 5.50187 7.24875 5.50187H10.5V14.5003Z"
        fill="#374151"
      />
    </g>
    <defs v-if="name === 'googleDrive'" xmlns="http://www.w3.org/2000/svg">
      <clipPath id="clip0_1_478">
        <rect width="12" height="16" fill="white" />
      </clipPath>
    </defs>
    <g v-if="name === 'small-post-icon'" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#1D0201"
        d="M6.5 6L6.5 2C6.5 1.72386 6.27614 1.5 6 1.5L2 1.5C1.72386 1.5 1.5 1.72386 1.5 2L1.5 6C1.5 6.27614 1.72386 6.5 2 6.5L6 6.5C6.27614 6.5 6.5 6.27614 6.5 6ZM8 2C8 0.895431 7.10457 -3.91405e-08 6 -8.74228e-08L2 -2.62268e-07C0.895431 -3.10551e-07 4.37697e-07 0.89543 3.89414e-07 2L2.14569e-07 6C1.66287e-07 7.10457 0.895431 8 2 8L6 8C7.10457 8 8 7.10457 8 6L8 2Z"
      />
    </g>
    <g v-if="name === 'medium-post-icon'" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#1D0201"
        d="M9.5 9L9.5 2C9.5 1.72386 9.27614 1.5 9 1.5L2 1.5C1.72386 1.5 1.5 1.72386 1.5 2L1.5 9C1.5 9.27614 1.72386 9.5 2 9.5L9 9.5C9.27614 9.5 9.5 9.27614 9.5 9ZM11 2C11 0.89543 10.1046 -3.91405e-08 9 -8.74228e-08L2 -3.93402e-07C0.895432 -4.41685e-07 9.14534e-07 0.89543 8.66252e-07 2L5.60272e-07 9C5.1199e-07 10.1046 0.895431 11 2 11L9 11C10.1046 11 11 10.1046 11 9L11 2Z"
      />
    </g>
    <g v-if="name === 'large-post-icon'" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#1D0201"
        d="M12 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V13C1.5 13.2761 1.72386 13.5 2 13.5H12C12.2761 13.5 12.5 13.2761 12.5 13V2C12.5 1.72386 12.2761 1.5 12 1.5ZM2 0C0.895431 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H12C13.1046 15 14 14.1046 14 13V2C14 0.895431 13.1046 0 12 0H2Z"
      />
    </g>
    <g v-if="name === 'small-post'" fill="none">
      <path
        d="M6.5 13L6.5 9C6.5 8.72386 6.27614 8.5 6 8.5L2 8.5C1.72386 8.5 1.5 8.72386 1.5 9L1.5 13C1.5 13.2761 1.72386 13.5 2 13.5L6 13.5C6.27614 13.5 6.5 13.2761 6.5 13ZM8 9C8 7.89543 7.10457 7 6 7L2 7C0.895431 7 4.37697e-07 7.89543 3.89414e-07 9L2.14569e-07 13C1.66287e-07 14.1046 0.895431 15 2 15L6 15C7.10457 15 8 14.1046 8 13L8 9Z"
      ></path>
      <path
        clip-rule="evenodd"
        fill-rule="evenodd"
        d="M0 2C0 0.895431 0.89543 0 2 0H12C13.1046 0 14 0.89543 14 2V13C14 14.1046 13.1046 15 12 15H2C0.89543 15 0 14.1046 0 13V2ZM2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V13C1.5 13.2761 1.72386 13.5 2 13.5H12C12.2761 13.5 12.5 13.2761 12.5 13V2C12.5 1.72386 12.2761 1.5 12 1.5H2Z"
        fill="#1E0202"
        fill-opacity="40%"
      ></path>
      <path
        clip-rule="evenodd"
        fill-rule="evenodd"
        d="M6.5 13L6.5 9C6.5 8.72386 6.27614 8.5 6 8.5L2 8.5C1.72386 8.5 1.5 8.72386 1.5 9L1.5 13C1.5 13.2761 1.72386 13.5 2 13.5L6 13.5C6.27614 13.5 6.5 13.2761 6.5 13ZM8 9C8 7.89543 7.10457 7 6 7L2 7C0.895431 7 4.37697e-07 7.89543 3.89414e-07 9L2.14569e-07 13C1.66287e-07 14.1046 0.895431 15 2 15L6 15C7.10457 15 8 14.1046 8 13L8 9Z"
        fill="#4b5563"
      ></path>
    </g>
    <g v-if="name === 'medium-post'" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V13C1.5 13.2761 1.72386 13.5 2 13.5H12C12.2761 13.5 12.5 13.2761 12.5 13V2C12.5 1.72386 12.2761 1.5 12 1.5ZM2 0C0.895431 0 0 0.89543 0 2V13C0 14.1046 0.895431 15 2 15H12C13.1046 15 14 14.1046 14 13V2C14 0.895431 13.1046 0 12 0H2Z"
        fill="#1E0202"
        fill-opacity="40%"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.5 13L9.5 6C9.5 5.72386 9.27614 5.5 9 5.5L2 5.5C1.72386 5.5 1.5 5.72386 1.5 6L1.5 13C1.5 13.2761 1.72386 13.5 2 13.5L9 13.5C9.27614 13.5 9.5 13.2761 9.5 13ZM11 6C11 4.89543 10.1046 4 9 4L2 4C0.895432 4 9.14534e-07 4.89543 8.66252e-07 6L5.60272e-07 13C5.1199e-07 14.1046 0.895431 15 2 15L9 15C10.1046 15 11 14.1046 11 13L11 6Z"
        fill="#4b5563"
      ></path>
    </g>

    <g v-if="name === 'large-post'" fill="none">
      <rect
        x="10.25"
        y="4.75"
        width="9.5"
        height="9.5"
        rx="1.25"
        transform="rotate(90 10.25 4.75)"
        stroke="#1E0202"
        stroke-opacity="40%"
        stroke-width="1.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V13C1.5 13.2761 1.72386 13.5 2 13.5H12C12.2761 13.5 12.5 13.2761 12.5 13V2C12.5 1.72386 12.2761 1.5 12 1.5ZM2 0C0.895431 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H12C13.1046 15 14 14.1046 14 13V2C14 0.895431 13.1046 0 12 0H2Z"
        fill="#1D0201"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2 3H12V0H2V3ZM3 2C3 2.55228 2.55228 3 2 3V0C0.89543 0 0 0.895431 0 2H3ZM3 13V2H0V13H3ZM2 12C2.55229 12 3 12.4477 3 13H0C0 14.1046 0.89543 15 2 15V12ZM12 12H2V15H12V12ZM11 13C11 12.4477 11.4477 12 12 12V15C13.1046 15 14 14.1046 14 13H11ZM11 2V13H14V2H11ZM12 3C11.4477 3 11 2.55229 11 2H14C14 0.89543 13.1046 0 12 0V3ZM1.5 2C1.5 1.72386 1.72386 1.5 2 1.5V-1.5C0.0670036 -1.5 -1.5 0.0670032 -1.5 2H1.5ZM1.5 13V2H-1.5V13H1.5ZM2 13.5C1.72386 13.5 1.5 13.2761 1.5 13H-1.5C-1.5 14.933 0.0670032 16.5 2 16.5V13.5ZM12 13.5H2V16.5H12V13.5ZM12.5 13C12.5 13.2761 12.2761 13.5 12 13.5V16.5C13.933 16.5 15.5 14.933 15.5 13H12.5ZM12.5 2V13H15.5V2H12.5ZM12 1.5C12.2761 1.5 12.5 1.72386 12.5 2H15.5C15.5 0.0670034 13.933 -1.5 12 -1.5V1.5ZM2 1.5H12V-1.5H2V1.5Z"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
import { computed, PropType } from "vue";
import {
  FontAwesomeIcon,
  FONT_AWESOME_ICONS,
  IconName,
} from "@/services/icons";
import FyrAiLogo from "@/components/Core/FyrAiLogo.vue";

const props = defineProps({
  name: {
    type: String as PropType<IconName>,
    default: "question-circle",
  },
  overrideColor: { type: Boolean, default: false },
});

const icon = computed((): FontAwesomeIcon => {
  return FONT_AWESOME_ICONS[props.name];
});
</script>
